"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthManager = void 0;
const auth_1 = require("firebase/auth");
/**
 * Auth Service Manager
 * Handles Firebase Authentication initialization and provider setup
 */
class AuthManager {
    constructor() {
        this.auth = null;
        this.googleProvider = null;
        this.initialized = false;
    }
    initialize(app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initialized && this.auth) {
                return this.auth;
            }
            try {
                console.log('🔑 AuthManager: Initializing Firebase Auth...');
                this.auth = (0, auth_1.getAuth)(app);
                this.setupGoogleProvider();
                this.initialized = true;
                console.log('✅ AuthManager: Auth service initialized');
                return this.auth;
            }
            catch (error) {
                console.error('❌ AuthManager: Failed to initialize Auth:', error);
                throw error;
            }
        });
    }
    setupGoogleProvider() {
        this.googleProvider = new auth_1.GoogleAuthProvider();
        // Configure Google provider
        this.googleProvider.addScope('profile');
        this.googleProvider.addScope('email');
        console.log('🔑 AuthManager: Google provider configured');
    }
    getInstance() {
        return this.auth;
    }
    getAuth() {
        if (!this.auth) {
            throw new Error('Auth not initialized. Call initialize() first.');
        }
        return this.auth;
    }
    getGoogleProvider() {
        if (!this.googleProvider) {
            throw new Error('Google provider not initialized. Call initialize() first.');
        }
        return this.googleProvider;
    }
    isInitialized() {
        return this.initialized && this.auth !== null;
    }
    /**
     * Reset manager for testing purposes
     */
    reset() {
        this.auth = null;
        this.googleProvider = null;
        this.initialized = false;
    }
}
exports.AuthManager = AuthManager;
